import {createSlice, PayloadAction} from '@reduxjs/toolkit';


type InitialStateType = {
    isOpenBurger: boolean,
}


const initialState: InitialStateType = {
    isOpenBurger: false,
}


const slice = createSlice({
    name: 'burger',
    initialState,
    reducers: {
        setOpenBurgerAC(state, action: PayloadAction<boolean>) {
            state.isOpenBurger = action.payload;
        },
    }
})


export const appReducer = slice.reducer
export const {setOpenBurgerAC} = slice.actions